
import { useState, useCallback, useRef, useEffect } from 'react';
import { logger } from "@/utils/logger";

interface Point {
  x: number;
  y: number;
  timestamp: number;
  id: number;
}

/**
 * Hook to track and manage touch points for debugging
 */
export const useDebugTouchPoints = (isActive: boolean) => {
  const [points, setPoints] = useState<Point[]>([]);

  // Clean up old points periodically
  useEffect(() => {
    if (!isActive) return;

    const cleanupInterval = setInterval(() => {
      const now = Date.now();
      setPoints(prev => prev.filter(p => now - p.timestamp < 3000));
    }, 1000);

    return () => {
      clearInterval(cleanupInterval);
    };
  }, [isActive]);

  const handleTouchStart = useCallback((e: TouchEvent) => {
    const touch = e.touches[0];
    if (!touch) return;

    const newPoint: Point = {
      x: touch.clientX,
      y: touch.clientY,
      timestamp: Date.now(),
      id: Math.random()
    };

    setPoints(prev => [...prev, newPoint]);

    // Log touch coordinates
    logger.info(`Touch at (${touch.clientX}, ${touch.clientY})`);

    // Get the element at this position
    const elementAt = document.elementFromPoint(touch.clientX, touch.clientY);

    logger.info('Element at position:', elementAt);

    // Check if it's inside a button
    const button = elementAt?.closest('button');

    if (button) {
      logger.info('Button at position:', button);
      const rect = button.getBoundingClientRect();
      logger.info('Button rect:', rect);
      logger.info('Touch Y relative to button:', touch.clientY - rect.top);
    }
  }, []);

  return { points, handleTouchStart };
};
